import service from "./fetchInterceptor";

const userService = {};

userService.getUsers = (limit, page, filters, q) => {
  return service.get(`/users`, {
    params: {
      limit,
      page,
      ...(filters && { ...filters }),
      ...(q && { q }),
    },
  });
};

userService.getUser = (params) => {
  return service.get(`/users/${params}`);
};

userService.setUser = (data) => {
  const { id, ...rest } = data;
  return service.patch(`/users/${id}`, rest);
};

userService.addUser = (data) => {
  return service.post("/users", data);
};

userService.removeUser = (params) => {
  return service.delete(`/users/${params}`);
};

// Exportar funciones individuales para compatibilidad
export const getUsers = userService.getUsers;
export const getUser = userService.getUser;
export const setUser = userService.setUser;
export const addUser = userService.addUser;
export const removeUser = userService.removeUser;

export default userService;
